import {Button} from 'alm-react-components';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import CarouselSection from '../../common/CarouselSection';
import {ActionType, APPROUTES, constants, PodcastTags} from '../../../assets/constants/constants';
import useLibrarySeeAll from '../../../hooks/useLibrarySeeAll';
import Search from '../../common/Search';
import useSearchhook from '../../../hooks/useSearchhook';
import {getPodcasts, librarySearch} from '../../../lib/utils';
import OtherSection from './OtherSection';
import { AppContext } from '../../../context/AppProvider';

function Podcasts() {
  const {getAllLibraryData, addBookMark, deleteBookMark, bookMarkresponse, data} =
    useLibrarySeeAll();
  const {keyword, onhandleSearch, onSearchClick} = useSearchhook();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [query] = useSearchParams()
  const routing = query.get('isHome')
  const {id} = useParams();
  const [, setLoading] = useState<boolean>(true);
  const {dispatch } = useContext(AppContext);

  
  const podcasts = getPodcasts()

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    getAllLibraryData(id).finally(()=>{
      setLoading(false);
    });
    setTimeout(() => setLoading(false), 1000);
  }, [bookMarkresponse, id]);

  const searchResult = keyword ? librarySearch(keyword, data) : data;

  const allResultsEmpty = PodcastTags.every((tag: any) => {
    const filteredData = searchResult.filter((item: any) => item?.attributes?.tags?.includes(tag));
    return filteredData.length === 0;
  });

  return (
    <div>
      <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
        <div className="flex justify-between items-center">
          <Button
           onClick={() =>{dispatch({ type: ActionType.SET_KEYWORD, payload:"" }); navigate(routing ? APPROUTES.home : APPROUTES.library)}}
            variant="default"
            className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
          >
            <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
          <Search onSearchClick={onSearchClick} onhandleSearch={onhandleSearch} />
        </div>

        {allResultsEmpty ? (
          <div className="flex justify-center items-center h-[calc(100vh-32rem)] w-full text-2xl">
            <p><span dangerouslySetInnerHTML={{ __html: (t('Library.noDetailsFound')) }} /></p>
          </div>
        ) : (
          <>
          {
          podcasts.map((res) => {
            const filteredData = searchResult
              ?.sort((a:any, b:any) =>
                b?.attributes?.localizedMetadata[0]?.name.localeCompare(
                  a?.attributes?.localizedMetadata[0]?.name,
                  'es',
                  { sensitivity: 'base' }
                )
              )
              .filter((item: { attributes: { tags: string | string[]; }; }) => item?.attributes?.tags?.includes(res?.tagName));
              console.log("shdbchcbhsdchhbdchbdhchdc",res.tagName)
            return (
              <div key={res?.tagName}>
                {filteredData.length ? (
                  <>
                    <h2 className="text-3xl font-barlowLight mt-6">{res?.label}</h2>
                    <CarouselSection
                      type={constants.PODCAST}
                      data={filteredData}
                      addBookMark={addBookMark}
                      deleteBookMark={deleteBookMark}
                      seeAll={true}
                      filterTag={res?.tagName}
                      catId={id}
                    />
                  </>
                ) : null}
              </div>
            );
          })
        }
           <OtherSection
          searchResult={searchResult}
          addBookMark={addBookMark}
          deleteBookMark={deleteBookMark}
          type={constants.PODCAST}
          data={data}
          keyword={keyword}
          catId={id} 
        />
        </>
        )}
      </div>
    </div>
  );
}

export default Podcasts;
